import { createContext } from 'react';

import { INITIAL_CONTEXT } from '~/constants/cart';
import { CartContextProps } from '~/types/cart';

export const CartContext = createContext(INITIAL_CONTEXT as CartContextProps);
